import { SET_VALIDATION_GROUP } from './constants';
import { SetValidationGroupAction } from './types';

export const setValidationGroupAction: SetValidationGroupAction =
  validationGroup => ({
    type: SET_VALIDATION_GROUP,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    payload: validationGroup,
  });
